import { defaultApiState } from '../api.state';

export const faqMutations = {
  GET_FAQS_LOADING(state) {
    state.apiState.getFaqs = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_FAQS_SUCCESS(state, payload) {
    state.apiState.getFaqs = {
      ...defaultApiState,
      success: true,
    };
    state.faqs = payload;
  },
  GET_FAQS_ERROR(state, error) {
    state.apiState.getFaqs = {
      ...defaultApiState,
      error,
    };
  },

  ADD_FAQ_LOADING(state) {
    state.apiState.addFaq = {
      ...defaultApiState,
      loading: true,
    };
  },
  ADD_FAQ_SUCCESS(state) {
    state.apiState.addFaq = {
      ...defaultApiState,
      success: true,
    };
  },
  ADD_FAQ_ERROR(state, error) {
    state.apiState.addFaq = {
      ...defaultApiState,
      error,
    };
  },

  GET_FAQ_RESET(state) {
    state.apiState.getFaq = {
      ...defaultApiState,
    };
    state.faq = undefined;
  },
  GET_FAQ_LOADING(state) {
    state.apiState.getFaq = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_FAQ_SUCCESS(state, payload) {
    state.apiState.getFaq = {
      ...defaultApiState,
      success: true,
    };
    state.faq = payload;
  },
  GET_FAQ_ERROR(state, error) {
    state.apiState.getFaq = {
      ...defaultApiState,
      error,
    };
  },

  UPDATE_FAQ_LOADING(state) {
    state.apiState.updateFaq = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPDATE_FAQ_SUCCESS(state) {
    state.apiState.updateFaq = {
      ...defaultApiState,
      success: true,
    };
  },
  UPDATE_FAQ_ERROR(state, error) {
    state.apiState.updateFaq = {
      ...defaultApiState,
      error,
    };
  },

  DELETE_FAQ_LOADING(state) {
    state.apiState.deleteFaq = {
      ...defaultApiState,
      loading: true,
    };
  },
  DELETE_FAQ_SUCCESS(state, payload) {
    state.apiState.deleteFaq = {
      ...defaultApiState,
      success: true,
    };
    state.faqs = state.faqs.filter(o => o.id !== payload.id);
  },
  DELETE_FAQ_ERROR(state, error) {
    state.apiState.deleteFaq = {
      ...defaultApiState,
      error,
    };
  },
};
